import { render } from "./AppNavItem.vue?vue&type=template&id=3bffd835"
import script from "./AppNavItem.vue?vue&type=script&lang=js"
export * from "./AppNavItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__